import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

import PasswordGate from './components/PasswordGate';
import RsvpModal from './components/RsvpModal';
import RSVP_OPEN from './config/rsvp';
import Navbar from './components/Navbar';

import Home from './pages/Home';
import RSVP from './pages/RSVP';
import Schedule from './pages/Schedule';
import TravelStay from './pages/TravelStay';
import ThingsToDo from './pages/ThingsToDo';
import Registry from './pages/Registry';
import FAQ from './pages/FAQ';
import Admin from './pages/Admin';
import WeddingParty from './pages/WeddingParty';
import LiveBeachCam from './pages/LiveBeachCam';

const FloorPlanner = lazy(() => import('./components/FloorPlanner'));

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Hide the site chrome on routes embedded inside the brand portal
function SiteNavbar() {
  const { pathname } = useLocation();
  if (pathname === '/floorplanner') return null;
  return <Navbar />;
}

const CORRECT_PASSWORD = 'MULLIGAN';
const AUTH_KEY = 'ferry_wedding_auth';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [showRsvpModal, setShowRsvpModal] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(AUTH_KEY) === 'true') {
      setAuthenticated(true);
    }
  }, []);

  const handleAuth = (password) => {
    if (password.toUpperCase().trim() === CORRECT_PASSWORD) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      setAuthenticated(true);
      if (RSVP_OPEN && sessionStorage.getItem('ferry_rsvp_modal_dismissed') !== 'true') {
        setShowRsvpModal(true);
      }
      return true;
    }
    return false;
  };

  if (!authenticated) {
    return <PasswordGate onAuth={handleAuth} />;
  }

  return (
    <>
      {showRsvpModal && <RsvpModal onClose={() => setShowRsvpModal(false)} />}
      <Router>
        <ScrollToTop />
        <SiteNavbar />
        <Routes>
          <Route path="/"        element={<Home />} />
          <Route path="/rsvp"    element={<RSVP />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/travel"  element={<TravelStay />} />
          <Route path="/things"  element={<ThingsToDo />} />
          <Route path="/registry" element={<Registry />} />
          <Route path="/faq"     element={<FAQ />} />
          <Route path="/beach-cam" element={<LiveBeachCam />} />
          <Route path="/admin"   element={<Admin />} />
          <Route path="/party"   element={<WeddingParty />} />
          <Route path="/floorplanner" element={
            <Suspense fallback={<p style={{ color: '#6b7280', textAlign: 'center', padding: '60px' }}>Loading floor planner…</p>}>
              <div style={{ minHeight: '100vh', background: '#faf9f6', padding: '16px' }}>
                <FloorPlanner />
              </div>
            </Suspense>
          } />
          <Route path="*"        element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
